module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"EDITOR":"Editor","REVIEWER":"Reviewer","ADMIN":"Admin"},"de":{"EDITOR":"Editor","REVIEWER":"Reviewer","ADMIN":"Admin"}}')
  delete Component.options._Ctor
}
